/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vang Pham (ptvang@rsupport.com)
 *
 * @description
 *
 * @created at Mon Sep 16 2024
 **/

import { Environments, Utility } from "@/frameworks/libraries/utilities";

import AudioPlayer from "./AudioPlayer";

export default function AudioViewer({ fileID, mimeType }: { fileID: string; mimeType: string }) {
	const partnerURL = Utility.URLNormalize(Environments.env<string>("URL_VIDEO"));

	return <AudioPlayer srcFile={`${partnerURL}/filebox/files/${fileID}`} type={mimeType} />;
}
